import { Component, Input, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { ValueAccessorBase } from '@capturum/ui/api';

@Component({
  selector: 'cap-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  providers: [ValueAccessorBase.getProviderConfig(CapturumRadioComponent)]
})
export class CapturumRadioComponent extends ValueAccessorBase<string> {
  @Input() public label: string;
  @Input() public name: string;
  @Input() public disabled: boolean = undefined;
  // tslint:disable-next-line:no-input-rename
  @Input('value') public radioValue: string;
  @ViewChild(NgModel, { static: true }) public model: NgModel;

  constructor() {
    super();
  }
}
